import React, { useState, useEffect } from 'react'
import { connect } from "react-redux";
import iconRight from '../../../../assets/images/Icon-arrow-right.png'
import { getSaleOrders, getOrderId, getSerialNumber, AddWarrantyExpiration, getItemPurchaseOrder } from "../../../../store/actions";
import { editClientData } from "../../../../store/actions";
import { format } from 'date-fns';
import Autocomplete from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';
import DatePicker from 'react-datepicker';
import "react-datepicker/dist/react-datepicker.css";

export const OutboundOrdersView = (props) => {

  const [editForm, setEditForm] = useState(true);
  const [orderID, setOrderID] = useState("");
  const [date, setDate] = useState("");
  const [deliveryDate, setDeliveryDate] = useState("");
  const [totalPrice, setTotalPrice] = useState("");
  const [qty, setQty] = useState("");
  const [clientInformation, setClientInformation] = useState([]);
  const [isBilled, setIsBilled] = useState();
  const [serialNumber, setSerialNumber] = useState("");
  const [loading, setLoading] = useState(false);
  const [title, setTitle] = useState("");
  const [CurrentDateModify, setCurrentDate] = useState("");
  const [DeliveryDateModify, setCurrentDeliveryDate] = useState("");
  const [dataSerial, setDataSerial] = useState("");
  const [allCompaniesList, setAllCompanies] = useState();
  const [serialLabel, setSerialLabel] = useState();
  const [serialEdit, setSerialEdit] = useState([]);
  const [isValid, setIsValid] = useState(true);
  const [isErrorMsg, setIsErrorMsg] = useState(false);
  const [errMsg, setErrMsg] = useState("");


  useEffect(() => {

    setOrderID(props.ClientDataReducer?.orderID);
    setDate(new Date(props.ClientDataReducer?.date));
    setDeliveryDate(new Date(props.ClientDataReducer?.deliveryDate));
    setTotalPrice(props.ClientDataReducer?.totalPrice);
    setQty(props.ClientDataReducer?.qty);
    setIsBilled(props.ClientDataReducer?.isBilled);
    setTitle(props.ClientDataReducer?.itemId.itemName);
    let CurrentDate = format(new Date(props.ClientDataReducer?.date), 'MMM dd yyyy');
    let CurrentDeliveryDate = format(new Date(props.ClientDataReducer?.deliveryDate), 'MMM dd yyyy');
    setCurrentDate(CurrentDate);
    setCurrentDeliveryDate(CurrentDeliveryDate);
    setSerialLabel(props.ClientDataReducer.serialList.toString())
    setSerialEdit(props.ClientDataReducer?.serialList)
    dataCurrent();
    allCompaniesListF()
  }, [])

  const editOrder = () => {
    setEditForm(!editForm)
  };
  const cancelEdit = () => {
    setEditForm(!editForm)
  }
  const DateCurrent = (date) => {
    setDate(date)
  };
  const deliveryDateCur = (date) => {
    setDeliveryDate(date)
  };

  const allCompaniesListF = async () => {
    let allCompanyList = []
    setAllCompanies(allCompanyList.records)
    let findClient = allCompanyList.records?.filter(res => res._id === props.ClientDataReducer?.clientInformationId)
    let clientInfo = {
      clientId: findClient[0]._id,
      clientName: findClient[0].companyName
    }
    setClientInformation(clientInfo)
    setLoading(true)
  }

  const setCompanyName = (values) => {
    let clientInfo = {
      clientId: values._id,
      clientName: values.companyName
    }
    setClientInformation(clientInfo)
  }


  const updateOrder = async ($e) => {
    $e.preventDefault();
    let payload = {
      id: props.ClientDataReducer?._id,
      orderID: orderID,
      date: date,
      deliveryDate: deliveryDate,
      totalPrice: totalPrice,
      qty: qty,
      clientInformation: clientInformation,
      isBilled: isBilled,
      serialList: serialEdit
    }
    if (serialEdit.length === Number(qty)) {
      await props.UpdateOutboundOrder(payload);
      props.closeSidebar()
    } else {
      setIsErrorMsg(true)
      setErrMsg(`Please match serial number and qty.`)
    }

  }

  const dataCurrent = async ($e) => {
    let data = await getItemPurchaseOrder();
    let getSerial = data.filter(res => res.itemId === props.ClientDataReducer?.itemId._id)
    let serialList = [];
    getSerial.forEach(element => {
      serialList.push(element.serialNumber[0])
    });
    setSerialNumber(serialList[0])
    setDataSerial(serialList[0])
  }

  const qtyChange = (e) => {
    let qtyLength = Number(e.target.value);
    let selectSerials = dataSerial.length
    let changeSerial = serialEdit.length
    if (selectSerials >= qtyLength) {
      if (qtyLength === changeSerial) {
        setIsErrorMsg(false)
        setIsValid(false)
      } else {
        if (qtyLength > changeSerial) {
          setIsErrorMsg(true)
          setErrMsg(`Please add ${qtyLength - changeSerial} more serial number or remove ${qtyLength - changeSerial} qty`)

        } else {
          setIsErrorMsg(true)
          setErrMsg(`Please remove ${changeSerial - qtyLength} serial number or add ${changeSerial - qtyLength} qty`)
        }
      }
    } else {
      setIsErrorMsg(true)
      setErrMsg(`You have only add ${selectSerials} Qty.`)
    }
    setQty(e.target.value)

  };

  const onSerialChange = (values) => {
    let qtyLength = Number(qty);
    if (qtyLength === values.length) {
      setIsErrorMsg(false)
      setIsValid(false)
    } else {
      if (qtyLength > values.length) {
        setIsErrorMsg(true)
        setErrMsg(`Please add  ${qtyLength - values.length}  more serial number or remove  ${qtyLength - values.length}  qty`)

      } else {
        setIsErrorMsg(true)
        setErrMsg(`Please remove ${values.length - qtyLength}  serial number or add ${values.length - qtyLength}  qty`)
      }
    }
    setSerialEdit(values)
  }


  return (
    <>
      {editForm ? (
        <div className={`AddPurchaseOrders`}>
          <div className="overlay-pop" onClick={props.closeSidebar}></div>
          <div className="userHeader d-flex align-items-center justify-content-between">
            <div className="UserName">
              <h2>Outbound Orders Detail: {orderID} </h2>
            </div>
            <div className="iconRight" onClick={props.closeSidebar}>
              <img src={iconRight} alt=""></img>
            </div>
          </div>
          <div className="item-body">
            <div className="itemList d-flex align-items-center justify-content-between">
              <div className="itemLabel">
                <span>Order ID</span>
              </div>
              <div className="itemOutput text-end">{orderID}</div>
            </div>

            <div className="itemList d-flex align-items-center justify-content-between">
              <div className="itemLabel">
                <span>Date</span>
              </div>
              <div className="itemOutput text-end">{CurrentDateModify}</div>
            </div>

            <div className="itemList d-flex align-items-center justify-content-between">
              <div className="itemLabel">
                <span>Delivery Date</span>
              </div>
              <div className="itemOutput text-end">{DeliveryDateModify}</div>
            </div>

            <div className="itemList d-flex align-items-center justify-content-between">
              <div className="itemLabel">
                <span>Total Price</span>
              </div>
              <div className="itemOutput text-end">{totalPrice}</div>
            </div>

            <div className="itemList d-flex align-items-center justify-content-between">
              <div className="itemLabel">
                <span>Client Name</span>
              </div>
              <div className="itemOutput text-end">
                {props.ClientDataReducer?.clientInformation}
              </div>
            </div>
            <div className="itemList d-flex align-items-center justify-content-between">
              <div className="itemLabel">
                <span>Qty</span>
              </div>
              <div className="itemOutput text-end">{qty}</div>
            </div>

            <div className="itemList d-flex align-items-center justify-content-between">
              <div className="itemLabel">
                <span>Item Name</span>
              </div>
              <div className={`itemOutput text-end`}>
                {props.ClientDataReducer?.itemId.itemName}
              </div>
            </div>

            <div className="itemList d-flex align-items-center justify-content-between">
              <div className="itemLabel">
                <span>Serial Numbers</span>
              </div>
              <div className="itemOutput text-end">{serialLabel}</div>
            </div>

            <div className="itemList d-flex align-items-center justify-content-between">
              <div className="itemLabel">
                <span>Billed</span>
              </div>
              <div className="itemOutput text-end">
                {isBilled ? "Yes" : "No"}
              </div>
            </div>
          </div>
          <div className="item-footer d-flex align-items-center justify-content-between">
            <div className="item-footer-inner">
              <button className="edit_btn" onClick={editOrder}>
                Edit
              </button>
            </div>
          </div>
        </div>
      ) : (
        <div className={`AddPurchaseOrders`}>
          <div className="overlay-pop" onClick={props.closeSidebar}></div>
          <form onSubmit={updateOrder}>
            <div className="userHeader d-flex align-items-center justify-content-between">
              <div className="UserName">
                <h2>Edit Outbound Orders Detail : {orderID}</h2>
              </div>
              <div className="iconRight" onClick={props.closeSidebar}>
                <img src={iconRight} alt=""></img>
              </div>
            </div>
            <div className="item-body">
              <div className="itemList d-flex align-items-center justify-content-between">
                <div className="itemLabel">
                  <span>Order ID</span>
                </div>
                <div className="itemOutput">
                  <input
                    type="number"
                    id="txtRole"
                    value={orderID}
                    onChange={(event) => setOrderID(event.target.value)}
                    required
                    readOnly
                  ></input>
                </div>
              </div>

              <div className="itemList d-flex align-items-center justify-content-between">
                <div className="itemLabel">
                  <span>Date</span>
                </div>
                <div className="itemOutput date-range">
                  <DatePicker
                    initialSettings={{
                      singleDatePicker: true,
                      startDate: date,
                      autoApply: true,
                    }}
                    onChange={DateCurrent}
                    selected={date}
                    todayButton="Today"
                  >
                  </DatePicker>
                </div>
              </div>
              <div className="itemList d-flex align-items-center justify-content-between">
                <div className="itemLabel">
                  <span>Delivery Date</span>
                </div>
                <div className="itemOutput text-end date-range">
                  <DatePicker
                    onChange={deliveryDateCur}
                    selected={deliveryDate}
                    minDate={date}
                    todayButton="Today"
                  >
                  </DatePicker>
                </div>
              </div>

              <div className="itemList d-flex align-items-center justify-content-between">
                <div className="itemLabel">
                  <span>Total Price</span>
                </div>
                <div className="itemOutput text-end">
                  <input
                    type="number"
                    id="txtRole"
                    value={totalPrice}
                    onChange={(event) => setTotalPrice(event.target.value)}
                    required
                  />
                </div>
              </div>

              <div className="itemList d-flex align-items-center justify-content-between">
                <div className="itemLabel">
                  <span>Client Name</span>
                </div>
                <div className={`itemOutput text-end autocomplete_field`}>
                  {loading ? (
                    <Autocomplete
                      id="tags-standard"
                      options={allCompaniesList}
                      getOptionLabel={(option) => option.companyName}
                      onChange={(e, v) => setCompanyName(v)}
                      defaultValue={{
                        companyName: props.ClientDataReducer?.clientInformation,
                      }}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          variant="standard"
                          placeholder="Serial Numbers"
                        />
                      )}
                    />
                  ) : (
                    "Loading"
                  )}
                </div>
              </div>

              <div className="itemList d-flex align-items-center justify-content-between">
                <div className="itemLabel">
                  <span>Item Name</span>
                </div>
                <div className={`itemOutput text-end`}>
                  <input
                    type="text"
                    id="txtRole"
                    value={props.ClientDataReducer?.itemId.itemName}
                    required
                    readOnly
                  />
                </div>
              </div>

              <div className="itemList d-flex align-items-center justify-content-between">
                <div className="itemLabel">
                  <span>Qty</span>
                </div>
                <div className="itemOutput text-end">
                  <input
                    type="text"
                    value={qty}
                    onChange={qtyChange}
                    required
                  />
                </div>
              </div>

              <div className="itemList d-flex align-items-center justify-content-between">
                <div className="itemLabel">
                  <span>Serial Numbers</span>
                </div>
                <div className="itemOutput text-end autocomplete_field">
                  <Autocomplete
                    multiple
                    id="tags-standard"
                    options={dataSerial}
                    getOptionLabel={(option) => option}
                    onChange={(e, v) => onSerialChange(v)}
                    defaultValue={props.ClientDataReducer?.serialList}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        variant="standard"
                        placeholder="Serial Numbers"
                      />
                    )}
                  />
                  {isErrorMsg ? <p>{errMsg}</p> : null}
                </div>
              </div>

              <div className="itemList d-flex align-items-center justify-content-between">
                <div className="itemLabel">
                  <span>Billed</span>
                </div>
                <div className="itemOutput text-start">
                  <input
                    type="checkbox"
                    defaultChecked={isBilled}
                    onChange={(event) => setIsBilled(event.target.checked)}
                  />
                </div>
              </div>
            </div>

            <div className="item-footer text-end">
              <button className="pop_wth_btn" onClick={cancelEdit}>
                Cancel
              </button>
              <button className="save-btn" type="submit">
                Save
              </button>
              {/* <button className="save-btn" type="submit" disabled={isValid} >Save</button> */}
            </div>
          </form>
        </div>
      )}
    </>
  );
}


const mapStateToProps = ({ UserReducer, ClientDataReducer, OrderIdReducer, SERIAL_NUMBER_R, OutboundOrderR }) => ({ UserReducer, ClientDataReducer, OrderIdReducer, SERIAL_NUMBER_R, OutboundOrderR });
export default connect(mapStateToProps, { getOutboundOrder: getSaleOrders, editClientData, getOrderId, getSerialNumber, AddWarrantyExpiration })(OutboundOrdersView);
